import {createContext, useContext, useEffect, useState} from 'react';

const AuthContext = createContext();

export const AuthProvider = ({children}) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [contextUser, setContextUser] = useState(null);

    const contextLogin = (userData) => {
        setContextUser(userData);
        setIsLoggedIn(userData.isLoggedIn);
        localStorage.setItem("hasEverHadSession", "1");
    };

    const contextLogout = () => {
        setContextUser(null);
        setIsLoggedIn(false);
    };

    return (
        <AuthContext.Provider value={{isLoggedIn, contextUser, contextLogin, contextLogout}}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('AuthProvider hasnt been initialized yet.');
    }
    return context;
}